<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="sm" :visible="modal.show" :data="model" :title="$t('Print Telephone Bids PDF')" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" :disableSubmitBtn="!selectedClerkList.length || !model.pdf_type"
                   scrollable>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="pdf_type" type="select2" :items="pdfTypes" display-field="${item.key}"
                        value-field="value"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <input-widget :model="model" attribute="allSelected" type="checkbox" @change="selectAllClerks"/>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-form-checkbox v-for="clerk in availableClerkList" v-model="selectedClerkList" :key="clerk.uuid"
                           :value="clerk.uuid" name="flavour-3a">
            <div class="mb-2">{{ clerk.name }}</div>
          </b-form-checkbox>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import InputWidget from "../../../core/components/input-widget/InputWidget.vue";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal.vue";
  import {createNamespacedHelpers} from "vuex";
  import AuctionClerk from "@/modules/pre-bids/models/AuctionClerk.model";
  import {ON_PDF_MODAL_DATA_RETRIEVE, ON_PDF_MODAL_OPEN} from "@/plugins/event-bus/event-bus-names";
  import PreBidsService from "@/modules/pre-bids/PreBidsService";
  import i18n from "@/shared/i18n";

  const {mapState, mapActions} = createNamespacedHelpers('preBids');
  const {mapActions: clerksMapActions} = createNamespacedHelpers('setup/branch');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "GeneratePdfModal",
    components: {
      InputWidget,
      ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: false,
        model: new AuctionClerk(),
        selectedClerkList: [],
        availableClerkList: [],
        pdfTypes: [
          {key: i18n.t('Default'), value: 'default'},
          {key: i18n.t('Group by Clerk'), value: 'group_by_clerk'},
        ]
      }
    },
    computed: {
      ...mapState({
        modal: state => state.generatePdfModal,
        sale: state => state.tableData[state.tableSource].sale
      }),
      ...mapStateGlobal({
        clerks: state => state.currentUser.branch.clerks,
        currentBranch: state => state.currentUser.branch
      }),
    },
    watch: {
      'selectedClerkList'() {
        if (this.selectedClerkList.length === 0 && this.availableClerkList.length === 0) {
          this.model.allSelected = false
        } else {
          this.model.allSelected = this.selectedClerkList.length === this.availableClerkList.length;
        }
      }
    },
    methods: {
      ...mapActions(['hideGeneratePdfModal', 'updateSaleClerks']),
      ...clerksMapActions({
        showClerksModal: 'showClerksModal'
      }),
      selectAllClerks: function () {
        this.selectedClerkList = [];
        if (!this.model.allSelected) {
          for (let clerk in this.availableClerkList) {
            this.selectedClerkList.push(this.availableClerkList[clerk].uuid.toString());
          }
        }
      },
      onShow() {
        this.availableClerkList = this.modal.object.clerks
      },
      onHidden() {
        this.model = new AuctionClerk();
        this.availableClerkList = [];
        this.selectedClerkList = [];
        this.hideGeneratePdfModal();
      },
      async onSubmit() {
        this.loading = true;

        const params = {
          auction_uuid: this.sale.uuid,
          pdf_type: this.model.pdf_type
        }

        if (!this.model.allSelected) {
          params.clerk_uuid = this.selectedClerkList.join(",")
        }

        this.$evBus.$emit(ON_PDF_MODAL_OPEN, {
          title: this.$i18n.t('Pre Bid Listing For Clerks')
        });

        const response = await PreBidsService.getPreBidsPdfData(params);
        if (response.success) {
          this.$evBus.$emit(ON_PDF_MODAL_DATA_RETRIEVE, {
            ...response.body,
            filename: "Telephone Bids PDF"
          })
        }
        this.loading = false;
      },
    },
  }
</script>

<style scoped>
  /deep/ .form-group {
    margin-bottom: 0.5rem;
  }
</style>
